import React, { FC } from 'react'
import styles from 'styles/components/image.module.scss'

type Props = {
  imageUrl: string
  alt: string
}

const PreviewImage: FC<Props> = (props) => {
  const { imageUrl, alt } = props
  return (
    <div className={styles.preview}>
      <img src={imageUrl} alt={alt} />
    </div>
  )
}

export default PreviewImage
